module.exports = __webpack_public_path__ + "img/betterfield_banner_sf.4b12f941.png";